const state = {
	postulants_index: {
		data: {},
		links: {},
		meta: {},
	},
};

export default state;
